<template>
    <div style="position: relative;">
        <top-bar-secondary>
            <template v-slot:module-action-left>
                <template v-if="isTemplateList">
                    <b-navbar-nav>
                        <b-nav-item @click="newTemplate">
                            <i class="cus-page-white-edit"></i>New Template
                        </b-nav-item>
                    </b-navbar-nav>
                </template>

                <!-- other page-template profile page-->
                <template v-else-if="isTemplate">
                    <b-navbar-nav
                        v-if="!isTemplateEditMode && !isSavingEditTemplate"
                    >
                        <b-nav-item
                            v-if="!isHideEditAndDeleteTemplate"
                            :disabled="!templateDetailsLoaded"
                            @click.stop="editTemplate"
                        >
                            <i class="cus-page-white-edit"></i>Edit Template
                        </b-nav-item>
                        <b-nav-item
                            :disabled="!templateDetailsLoaded"
                            @click.stop="duplicateTemplate"
                        >
                            <i class="cus-page-copy"></i>Duplicate
                        </b-nav-item>
                        <b-nav-item
                            v-if="!isHideEditAndDeleteTemplate"
                            :disabled="!templateDetailsLoaded"
                            @click.stop="deleteTemplate"
                        >
                            <i class="cus-delete"></i>Delete Template
                        </b-nav-item>
                    </b-navbar-nav>

                    <b-navbar-nav
                        v-else-if="isTemplateEditMode && !isSavingEditTemplate"
                    >
                        <b-nav-item @click.stop="saveEditTemplate">
                            <i class="cus-page-white-edit"></i>
                            <span>Save + Done </span>
                        </b-nav-item>
                        <b-nav-item @click.stop="cancelEditTemplate">
                            <i class="cus-cancel"></i>Cancel
                        </b-nav-item>
                    </b-navbar-nav>

                    <b-navbar-nav v-else-if="isSavingEditTemplate">
                        <b-nav-item>
                            <i class="cus-hourglass"></i>Saving...
                        </b-nav-item>
                    </b-navbar-nav>
                </template>
                <!-- For Payment Onboarding -->
                <template v-else-if="isPaymentOnboarding">
                    <b-navbar-nav>
                        <b-nav-item
                            v-if="
                                env.VUE_APP_ENV !== 'PROD' || staffIsWhitelist
                            "
                            @click="manageKeys"
                        >
                            <i class="cus-page-white-edit hide"></i>Manage Keys
                        </b-nav-item>
                        <!-- <b-nav-item>
                                <i class="cus-page-white-edit hide"></i>Disabled Add On
                            </b-nav-item>
                            <b-nav-item>
                                <i class="cus-page-white-edit hide"></i>View Devices
                            </b-nav-item> -->
                    </b-navbar-nav>
                </template>

                <template v-if="isStaffProfile && isNotifcationFeatureEnabled">
                    <!-- TODO: To update when building staff'r profile page -->
                    <!-- TODO: Display only to logged in user own's profile page -->
                    <!-- TODO: Hide when logged in user is displaying other staff's profile page -->
                    <b-navbar-nav>
                        <b-nav-item
                            :to="
                                '/settings/staff/profile/' +
                                staff.encoded_id +
                                '/notifications'
                            "
                        >
                            <i class="cus-bell"></i>Notification Settings
                        </b-nav-item>
                    </b-navbar-nav>
                </template>

                <template v-if="isNotificationSetting">
                    <b-navbar-nav>
                        <b-nav-item
                            :to="'/settings/users/view/' + staff.encoded_id"
                        >
                            <i class="famfamfam-silk user"></i>View Profile
                        </b-nav-item>
                    </b-navbar-nav>
                </template>
                <!-- For New Staff -->
                <template
                    v-else-if="isStaffList && _hasAccess('setting.staff.add')"
                >
                    <b-navbar-nav>
                        <b-nav-item
                            :disabled="disableStaffButton()"
                            @click.prevent="goToNewStaff()"
                        >
                            <i class="cus-add"></i>
                            New Staff
                            <span
                                v-show="staffQuota !== null && staffQuota >= 0"
                            >
                                ( {{ staffQuota }} quota left )
                            </span>
                        </b-nav-item>
                    </b-navbar-nav>
                </template>

                <template v-else-if="isStaffNew">
                    <b-navbar-nav>
                        <b-nav-item
                            v-b-tooltip.hover="
                                isDisableSaveNewStaff
                                    ? {
                                          placement: 'top',
                                          title:
                                              'Out of balance quota to add new staff'
                                      }
                                    : {
                                          title: ''
                                      }
                            "
                            :disabled="isDisableSaveNewStaff"
                            @click="saveNewStaff"
                        >
                            <i class="cus-disk"></i>Save + Done
                        </b-nav-item>
                        <b-nav-item @click.prevent="goToStaffList()"
                            ><i class="cus-cancel"></i>Cancel
                        </b-nav-item>
                    </b-navbar-nav>
                </template>

                <template v-else>
                    <b-navbar-nav>
                        <b-nav-item>
                            <!-- For Page with no Menu -->
                            <div class="text-blend-in">|</div>
                        </b-nav-item>
                    </b-navbar-nav>
                </template>
            </template>
        </top-bar-secondary>

        <content-wrapper>
            <router-view
                ref="templateView"
                @open-dialog="newTemplate"
            ></router-view>
        </content-wrapper>

        <modal-delete-template
            v-if="templateType"
            ref="modalDeleteTemplate"
            @onsuccess="redirectToTemplates"
        />
        <modal-duplicate-template ref="modalDuplicateTemplate" />
        <modal-new-template
            @onsuccess="getListRefresh"
            ref="modalNewTemplate"
        />
        <modal-confirm-supplier
            v-if="isPurchaseOrder"
            ref="modalConfirmSupplier"
            @proceed="proceedSaveEdit(true)"
        />
        <modal-manage-keys ref="modalManageKeys" />
    </div>
</template>
<style type="text/css">
.text-blend-in {
    color: #c9ccde;
}

.disabled {
    opacity: 0.5;
    cursor: not-allowed;
}
</style>

<script>
import ModalDeleteTemplate from "@/components/setting-template/modal-delete-template";
import ModalDuplicateTemplate from "@/components/setting-template/modal-duplicate-template";
import ModalNewTemplate from "@/components/setting-template/modal-new-template";
import ModalConfirmSupplier from "@/module/settings/template/modal-confirm-po-supplier";
import ModalManageKeys from "@/components/payments/manage-keys";
import TEMPLATES from "@/constants/templates";
import { get } from "lodash";
import FeaturesEnabledMixin from "@/mixins/features-enabled";
import TopBarSecondary from "@/module/layout/top-bar-secondary.vue";
import ContentWrapper from "@/module/layout/content-wrapper.vue";

export default {
    components: {
        ModalDeleteTemplate,
        ModalConfirmSupplier,
        ModalDuplicateTemplate,
        ModalNewTemplate,
        ModalManageKeys,
        TopBarSecondary,
        ContentWrapper
    },
    data() {
        return {};
    },
    mixins: [FeaturesEnabledMixin],
    computed: {
        staff() {
            return this.$root.currentActor;
        },
        isTemplateList() {
            return this.$route.name == "template_list";
        },
        isPaymentOnboarding() {
            return this.$route.name == "payments";
        },
        staffIsWhitelist() {
            return this.$root.currentActor.is_whitelist;
        },
        isWebform() {
            return this.templateType == TEMPLATES.TYPE.WEBFORM_TEMPLATE;
        },
        isPurchaseOrder() {
            return this.templateType == TEMPLATES.TYPE.PURCHASE_ORDER;
        },
        isNotificationSetting() {
            return this.$route.name == "notifications-setting";
        },
        isStaffProfile() {
            return this.$route.name == "staff_profile";
        },
        isTemplate() {
            let templateRouteNames = [
                "template_details",
                "template_purchase_order"
            ];
            return templateRouteNames.includes(this.$route.name);
        },
        isTemplateEditMode() {
            return this.$store.state.settingsTemplate.isEditMode;
        },
        isSavingEditTemplate() {
            return this.$store.state.settingsTemplate.isSavingEdit;
        },
        templateDetails() {
            return this.$store.state.settingsTemplate.details;
        },
        templateId() {
            return this.$store.state.settingsTemplate.templateId;
        },
        templateType() {
            return this.$store.state.settingsTemplate.templateType;
        },
        templateDetailsLoaded() {
            // used to prevent user click the edit, duplicate and delete before the data successfully rendered
            return this.templateId;
        },
        staffStatus() {
            return this.$store.getters["staff/status"];
        },
        isStaffList() {
            return this.$route.name == "stafflist";
        },
        isStaffNew() {
            return this.$route.name == "staff_new";
        },
        staffQuota() {
            return this.$store.getters["staff/quota"];
        },
        isDisableSaveNewStaff() {
            if (this.staffQuota == null) {
                // NOTE: when null, it means unlimited quota
                return false;
            }
            return this.staffQuota <= 0;
        },
        isSavingNewStaff() {
            return this.$store.getters["staff/isLoadingDetailsForm"];
        },
        isHideEditAndDeleteTemplate() {
            return (
                Number(
                    this.$store.state.settingsTemplate.details
                        .wellness_plan_enrollees
                ) > 0 && this.templateType == TEMPLATES.TYPE.WELLNESS_PLAN
            );
        }
    },
    sockets: {
        "v-broadcast-all"(params) {
            if (params.action === "close-vetcove-dialog") {
                console.log("close-vetcove-dialog socket");
                var w = window.open("", "vetCoveOnlineLoginWindow");
                console.log(w);
                w.close();
            }
        }
    },
    watch: {
        templateDetails(detail) {
            if (!detail.id) {
                return;
            }

            const templateType = TEMPLATES.LIST[detail.type];

            this.dynamicPageTitle(`${detail.name} - ${templateType.label}`);
        }
    },
    methods: {
        getListRefresh() {
            this.$refs.templateView.getRefreshList();
        },
        newTemplate(temp) {
            this.$refs.modalNewTemplate.open(temp);
        },
        editTemplate() {
            this.$store.dispatch("settingsTemplate/startEdit");
        },
        cancelEditTemplate() {
            this.$store.commit("settingsTemplate/toggleEdit", false);
        },
        duplicateTemplate() {
            this.$refs.modalDuplicateTemplate.open({
                templateId: this.templateDetails.id,
                templateName: this.isPurchaseOrder
                    ? this.templateDetails.title
                    : this.templateDetails.name,
                templateType: this.templateDetails.type,
                templateDescription: this.templateDetails.description,
                isOpenFromTemplateProfile: true
            });
        },
        deleteTemplate() {
            if (this.isPurchaseOrder) {
                this.templateDetails.name = this.templateDetails.title;
            }
            this.$refs.modalDeleteTemplate.open(this.templateDetails);
        },
        async saveEditTemplate() {
            try {
                // separate the function update for each templates
                if (this.isWebform) {
                    await this.$refs.templateView.$refs.webformDetail.save();
                    return;
                } else if (this.isPurchaseOrder) {
                    let {
                        details,
                        editDetails
                    } = this.$store.state.settingsTemplate;

                    let newSupplierId = null;
                    let currentSupplierId = null;

                    if (editDetails && editDetails.supplier) {
                        newSupplierId = editDetails.supplier.value;
                    }

                    if (details && details.supplier) {
                        currentSupplierId = details.supplier.value;
                    }

                    /*
                    alert popup change supplier:
                    if previous supplier is already set, and the new one is not same as the previous.
                    if current supplier is null, then we won't show the alert popup BUT,
                    if current supplier is null, but the new supplier is "integrated" supplier, then we'll show the alert
                    */

                    // if both not null AND both not same, // show alert
                    if (
                        newSupplierId &&
                        currentSupplierId &&
                        newSupplierId !== currentSupplierId
                    ) {
                        this.$refs.modalConfirmSupplier.open();
                    } else {
                        this.proceedSaveEdit(false);
                    }
                } else {
                    // For others type (so far only letter and snippet)
                    // TODO: Refactor this by move the if else type in proceedSaveEdit to here, perhap change to switch in here
                    this.proceedSaveEdit(false);
                }
            } catch (error) {
                this.$store.commit("settingsTemplate/toggleEdit", false);
                this._message(error.message, "danger");
            }
        },
        redirectToTemplates() {
            this.$router.push({
                name: "template_list",
                params: { type: TEMPLATES.LIST[this.templateType].route }
            });
        },
        async proceedSaveEdit(removeAllItems = false) {
            switch (this.templateType) {
                case TEMPLATES.TYPE.CONTENT_SNIPPET:
                    this.$refs.templateView.$refs.snippetDetail.saveDetails();
                    break;
                case TEMPLATES.TYPE.LETTER:
                    this.$refs.templateView.$refs.letterDetail.saveDetails();
                    break;
                case TEMPLATES.TYPE.MEDICAL_NOTE:
                    this.$refs.templateView.$refs.medicalNoteDetail.saveDetails();
                    break;
                case TEMPLATES.TYPE.BUNDLE:
                    this.$refs.templateView.$refs.invoiceDetail.saveDetails();
                    break;
                case TEMPLATES.TYPE.BUNDLE_ESTIMATE:
                    this.$refs.templateView.$refs.estimateDetail.saveDetails();
                    break;
                case TEMPLATES.TYPE.WELLNESS_PLAN:
                    this.$refs.templateView.$refs.wellnessPlanDetail.saveDetails();
                    break;
                default:
                    await this.$store.dispatch("settingsTemplate/saveEdit", {
                        removeAllItems: removeAllItems
                    });
                    this._message("Record saved");
            }
        },
        manageKeys() {
            this.$refs.modalManageKeys.open();
        },
        disableStaffButton() {
            if (this.staffQuota == null || this.staffQuota > 0) {
                return false;
            }
            return true;
        },
        async saveNewStaff() {
            if (this.isSavingNewStaff || this.isDisableSaveNewStaff) {
                return;
            }
            this.$store.commit("staff/setIsLoadingDetailsForm", true);

            try {
                const res = await this.$store.dispatch("staff/saveNewStaff");

                const resCode = get(res, "message.code", null);

                const resMessageSuccess = get(res, "message.description", "");
                const resMessageError = get(res, "message.error", "");

                const resEncodedId = get(res, "resource.encoded_id", "");

                if (resCode && resCode == 200) {
                    if (resMessageSuccess && resEncodedId) {
                        this.$router.push({
                            name: "staff_view",
                            params: { id: resEncodedId }
                        });
                    } else if (resMessageError) {
                        this._message(resMessageError, "danger");
                    } else {
                        throw new Error("Error: Unable to save new staff");
                    }
                }
            } catch (e) {
                this._message(e.message, "danger");
            }

            this.$store.commit("staff/setIsLoadingDetailsForm", false);
        },
        goToNewStaff() {
            this.$router.push({ name: "staff_new" });
        },
        goToStaffList() {
            this.$router.push({
                name: "stafflist",
                query: {
                    status: this.staffStatus.label.toLowerCase()
                }
            });
        }
    }
};
</script>
ha
